<template>
  <div>
    <h1 class="display-4">Liste des établissements</h1>
    <hr />

    <router-link tag="p" to="/establishment/edit">
      <a class="btn btn-large btn-primary">Ajouter un établissement</a>
    </router-link>

    <b-table class="mt-3" :dark="theme == 'dark'" responsive hover striped :items="establishments" :fields="fields" :current-page="currentPage" :per-page="perPage" v-show="totalRows > 0">
      <template slot="school" slot-scope="cell">
        {{ cell.item.school.name }}
      </template>
      <template slot="city" slot-scope="cell">
        {{ cell.item.city.name }}
      </template>
      <template slot="actions" slot-scope="cell">
        <router-link tag="a" class="btn btn-sm btn-primary" :to="{ name: 'EstablishmentEditExist', params: {id: cell.item.id } }">
          Editer
        </router-link>
      </template>
    </b-table>

    <b-row v-show="totalRows > perPage">
      <b-col md="6" class="my-1">
        <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
      </b-col>
    </b-row>

    <p class="text-center" v-show="totalRows == 0"><em>Il y a aucun établissement pour le moment...</em></p>
  </div>
</template>

<script>
import Vue from 'vue'
import VueResource from 'vue-resource'
import Vuex from 'vuex'
import Paginate from 'vuejs-paginate'

Vue.component('paginate', Paginate)
Vue.use(VueResource)

export default {
  data () {
    return {
      currentPage: 1,
      establishments: [],
      fields: {
        id: {
          label: '#',
          sortable: false
        },
        school: {
          label: 'Ecole',
          sortable: false
        },
        city: {
          label: 'Ville',
          sortable: false
        },
        actions: {
          label: 'Actions',
          key: 'actions'
        }
      },
      perPage: 20
    }
  },
  computed: {
    ...Vuex.mapGetters(['access_token', 'domain', 'theme']),
    totalRows () {
      return this.establishments.length
    }
  },
  mounted () {
    this.$http.get(this.domain + '/api/establishments?filter[include]=school&filter[include]=city&access_token=' + this.access_token).then((response) => {
      response.json().then((data) => {
        this.establishments = data
      })
    }, (response) => {

    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Establishments/List.vue